require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./forms-2-sliders-and-buttons.json") })
        }
      }, "path---forms-2-sliders-and-buttons");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---forms-2-sliders-and-buttons!./.cache/json/forms-2-sliders-and-buttons.json
// module id = 388
// module chunks = 231608221292675